import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import VueResource from 'vue-resource'
Vue.use(VueResource);

import PubNubVue from 'pubnub-vue'

Vue.config.productionTip = false

 
const publish_Key = 'pub-c-528ebec3-92d2-470a-a64c-9f4ea36b9551';
const subscribe_Key = 'sub-c-ef2a7566-0031-11eb-a091-569464a6854f';
// Make a unique uuid for each client
/*const myUuid = fourCharID();
const me = {
  uuid: myUuid,
};
*/
try{
  if(!publish_Key || !subscribe_Key){
    throw 'PubNub Keys are missing.';
  }
}
catch(err){
  console.log(err);
}




Vue.use(PubNubVue, {
  subscribeKey: subscribe_Key,
  publishKey: publish_Key,
  ssl: false
}, store);


import '@fortawesome/fontawesome-free/css/all.css'
import '@fortawesome/fontawesome-free/js/all.js'

import 'bootstrap/dist/css/bootstrap.css'
import './app.scss'

Vue.mixin({
  methods: {

    isNull: function (str)
    {
      return (str == '' || str == null || str == undefined);
    },

    api_call: function(settings){

        if (this.isNull(settings.onComplete))
        {
          settings.onComplete = function(){};
        }
        else
        {
          var real_func = settings.onComplete;
          settings.onComplete = function(data){
            real_func(data);
          };
        }
        
        if (settings.async === false) settings.async = false;
        else settings.async = true;
        
        if (this.isNull(settings.data)) settings.data = {};
        settings.data.api_user_token = localStorage.getItem('user_token');
        
        //return this.$http.post(window.api_url + settings.url + '?&ts=' + (new Date()).getHours() + '_' + ((new Date()).getMinutes() < 30 ? '0' : '30') , settings.data).then(settings.onComplete);
          return this.$http.post(window.api_url + settings.url , settings.data).then(settings.onComplete);

    },

    is_mobile: function(){ 

      return ( navigator.userAgent.match(/Android/i)
   || navigator.userAgent.match(/webOS/i)
   || navigator.userAgent.match(/iPhone/i)
  // || navigator.userAgent.match(/iPad/i)
   || navigator.userAgent.match(/iPod/i)
   || navigator.userAgent.match(/BlackBerry/i)
   );
  },
  add_to_fav(id){
      
    var self = this;
    
    var settings = { 
      item_id: id, 
      api_user_token: localStorage.getItem('user_token')
    };

    this.$http.post(window.api_url + 'user/add_favorite', settings)
    .then(function(/*data*/){
      
      self.$alert('הסרט נוסף לרשימת הצפייה שלך');
      
    });
    

  }

   }
  })
  

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
/*
function fourCharID() {
  const maxLength = 4;
  const possible = 'abcdef0123456789';
  let text = '';
  for (let i = 0; i < maxLength; i++) {
    text += possible.charAt(Math.floor(Math.random() * possible.length));
  }
  return text;
}
*/